"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipContainer = void 0;
var React = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var ChipContainerWrapper = styles_1.styled("div")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        display: "flex",
        justifyContent: "left",
        flexWrap: "wrap",
        "& > *": {
            margin: spacing(0.5, 1, 0.5, 0),
        },
        "label + [class*='MuiInputBase-formControl'] > [class*='MuiSelect-selectMenu'] > &": {
            marginTop: spacing(-0.5),
            marginBottom: spacing(-0.5),
        },
    });
}, { name: "EuiChipContainer" });
exports.ChipContainer = React.forwardRef(function ChipContainer(_a, ref) {
    var _b = _a.role, role = _b === void 0 ? "list" : _b, childrenProp = _a.children, props = __rest(_a, ["role", "children"]);
    // Accessibility roles added to children by default
    var children = React.Children.map(childrenProp, function (child) {
        if (!React.isValidElement(child))
            return null;
        if (child.type && child.type === React.Fragment)
            return child;
        return React.cloneElement(child, __assign({ role: "listitem" }, child.props));
    });
    return (React.createElement(ChipContainerWrapper, __assign({}, props, { role: role, ref: ref }), children));
});
//# sourceMappingURL=ChipContainer.js.map